const Quote = (() => {
    const DOM = {};

    const cacheDOM = () => {
        DOM.conveyancing = document.getElementsByClassName('convey-button');
        DOM.wills = document.getElementsByClassName('wills-button');
        DOM.conveyancingSelectElement = document.getElementById('pick-conveyancing');
        DOM.willsSelectElement = document.getElementById('pick-wills');
        DOM.conveyancingOptions = document.getElementsByClassName('hoowla-option-block');
        DOM.willsOptions = document.getElementsByClassName('hoowla-wills-block');
        DOM.buttonOptions = document.getElementsByClassName('button-group__wrapper')[0];
        DOM.infobar = document.querySelector('.infobar');
    }
    const toggleButtonDisplay = (e) => {
        e.preventDefault();

        // Move infobar to the header/button
        let buttonParent = e.target;
        if (buttonParent.parentElement.classList.contains('quote-container')) {
            buttonParent.after(DOM.infobar);
        } else {
            document.querySelector('.top-bar').after(DOM.infobar);
        }

        loadAssetFile();

        const buttonsSelectElements = [
            DOM.conveyancingSelectElement.nextElementSibling,
            DOM.willsSelectElement.nextElementSibling
        ];
        buttonsSelectElements.forEach(selectElements => {
            selectElements.classList.remove('is-active');
            selectElements.setAttribute('data-value', '');
            selectElements.innerHTML = '<span>Choose Branch..</span>';
        });

        if (e.currentTarget.classList.contains('is-active')) {
            e.currentTarget.classList.remove('is-active');
            DOM.buttonOptions.classList.remove('is-active');
            hideOptions();
        } else {
            const one = Array.prototype.slice.call(DOM.conveyancing);
            const two = Array.prototype.slice.call(DOM.wills);
            const buttons = [...one, ...two];
            buttons.forEach(button => button.classList.remove('is-active'));

            e.currentTarget.classList.add('is-active');
            DOM.buttonOptions.classList.add('is-active');

            const dropdownButton = e.currentTarget.classList.contains('convey-button')
                ? DOM.conveyancingSelectElement.nextElementSibling
                : DOM.willsSelectElement.nextElementSibling

           dropdownButton.classList.add('is-active');
        }

        listenForSelection(DOM.conveyancingSelectElement.nextElementSibling, displayQuoteLink);
        listenForSelection(DOM.willsSelectElement.nextElementSibling, displayQuoteLink);
    }

    const hideOptions = () => {
        Array.from(DOM.conveyancingOptions).forEach(option => {
            option.classList.remove('is-active');
            option.style.height = 0;
        });
        Array.from(DOM.willsOptions).forEach(option => {
            option.classList.remove('is-active');
            option.style.height = 0;
        });
    }

    const displayQuoteLink = (element) => {
        hideOptions();

        const buttonSelected = element.previousElementSibling.id;
        const optionSelected = element.getAttribute('data-value');

        const blockA = document.getElementsByClassName('hoowla-option-block block-a')[0];
        const blockB = document.getElementsByClassName('hoowla-option-block block-b')[0];
        const blockC = document.getElementsByClassName('hoowla-option-block block-c')[0];

        const blockD = document.getElementsByClassName('hoowla-wills-block block-d')[0];
        const blockE = document.getElementsByClassName('hoowla-wills-block block-e')[0];
        const blockF = document.getElementsByClassName('hoowla-wills-block block-f')[0];

        switch (optionSelected) {
            case '1':
                const option1 = buttonSelected === 'pick-conveyancing' ? blockA : blockD;
                option1.classList.add('is-active');
                // option1.style.height = option1.offsetHeight + 'px';
                option1.style.height = '46px';
                break;
            case '2':
                const option2 = buttonSelected === 'pick-conveyancing' ? blockB : blockE;
                option2.classList.add('is-active');
                // option2.style.height = option2.offsetHeight + 'px';
                option2.style.height = '46px';
                break;
            case '3':
                const option3 = buttonSelected === 'pick-conveyancing' ? blockC : blockF;
                option3.classList.add('is-active');
                // option3.style.height = option3.offsetHeight + 'px';
                option3.style.height = '46px';
                break;
            default:
                break;
        }
    }

    const loadAssetFile = () => {
        const id = 'hoowla-js-async';

        if (document.getElementById(id)) {
            return;
        }

        const s = document.createElement('script');
        s.async = true;
        s.id = id;
        s.src = 'https://cdn.hoowla.com/hoowla-quote-plugin-min.js';
        const e = document.getElementsByTagName('script')[0];
        e.parentNode.insertBefore(s, e);
    }

    const listenForSelection = (target, callback) => {
        const observer = new MutationObserver(mutations => {
            mutations.forEach(mutation => {
                if (mutation.type === "attributes") {
                    callback(mutation.target);
                }
            });
        });

        const config = { attributes: true, childList: false, subtree: false };

        observer.observe(target, config);
    };

    const eventListeners = () => {

        for (let i = 0; i < DOM.conveyancing.length; i += 1) {
            DOM.conveyancing[i].addEventListener("click", toggleButtonDisplay);
        }
        for (let i = 0; i < DOM.wills.length; i += 1) {
            DOM.wills[i].addEventListener("click", toggleButtonDisplay);
        }

        // DOM.conveyancing.addEventListener('click', toggleButtonDisplay);
        // DOM.wills.addEventListener('click', toggleButtonDisplay);
    }

    const init = () => {
        cacheDOM();

        if ( DOM.conveyancing || DOM.wills ) {
            hideOptions();
            eventListeners();
        }
    }

    return {
        init
    }
})();
export default Quote;
